// ./src/components/features/Venues/VenueRequirementsEditor/venueRequirementRows.ts
//
// ROADMAP #170 (owner, 2026-10-20) — the venue form's rows for "Vendors must provide", and the whole list to save.
// Relative imports only, so a guard can run them.
import type { VenueRequirement, VenueRequirementInput } from "../../../../utils/api/EventVendorService";

export interface VenueRequirementRow {
  /** Stable local key for React lists (NOT sent). */
  key: string;
  /** The saved requirement — absent for a new row. */
  id?: string;
  documentType: string;
  documentKind: string;
  /** Only vendors of this (service) category; null = every vendor. */
  venueCategoryId: string | null;
  /** Due this many days before the event; null = no due date. */
  dueDaysBefore: number | null;
  instructions: string;
  /** What the document must show. */
  checks: string[];
}

let keySeq = 0;
const nextKey = (): string => {
  keySeq += 1;

  return `venue-requirement-${keySeq}`;
};

export const createEmptyVenueRequirement = (documentType: string): VenueRequirementRow => ({
  key: nextKey(),
  documentType,
  documentKind: "",
  venueCategoryId: null,
  dueDaysBefore: null,
  instructions: "",
  checks: [],
});

/** Editor rows from the saved list (in its order). */
export const venueRequirementRowsFrom = (rows: VenueRequirement[] | null | undefined): VenueRequirementRow[] =>
  (rows ?? []).map((r) => ({
    key: nextKey(),
    id: r.id,
    documentType: r.documentType ?? "",
    documentKind: r.documentKind ?? "",
    venueCategoryId: r.venueCategoryId ?? null,
    dueDaysBefore: r.dueDaysBefore ?? null,
    instructions: r.instructions ?? "",
    checks: r.checks ?? [],
  }));

/** The whole list to save, in order. Values are sent as typed — the server checks each and refuses at its row. */
export const venueRequirementRowsToInput = (rows: VenueRequirementRow[]): VenueRequirementInput[] =>
  rows.map((r) => ({
    ...(r.id ? { id: r.id } : {}),
    documentType: r.documentType,
    documentKind: r.documentKind.trim() || null,
    venueCategoryId: r.venueCategoryId,
    dueDaysBefore: r.dueDaysBefore,
    instructions: r.instructions.trim() || null,
    checks: r.checks.map((check) => check.trim()).filter(Boolean),
  }));
